export const PATHS = {
  home: "/",
  quemSomos: "/quem-somos",
  metodologia: "/metodologia",
  ondeEstamos: "/onde-estamos",
  paraEmpresas: "/para-empresas",
  blog: "/blog",
  transparencia: "/transparencia",
  contato: "/contato",
  apoie: "/apoie",

  login: "/login",
  forgotPassword: "/esqueci-senha",
  resetPassword: "/redefinir-senha",
  admin: "/admin",
  adminHome: "/admin/home",
  adminCidades: "/admin/cidades",
  adminCidadeNova: "/admin/cidades/nova",
  adminCidade: "/admin/cidades/:slug",
  adminBlog: "/admin/blog",
  adminContato: '/admin/contato',
  adminMetodologia: '/admin/metodologia',
  adminParaEmpresas: "/admin/para-empresas",
  adminApoie: "/admin/apoie",
  adminTransparencia: "/admin/transparencia",
  transparenciaFile: "/transparencia-file/:category/:id?",
  adminQuemSomos: "/admin/quem-somos",
  adminRodape: "/admin/rodape",
  adminCabecalho: "/admin/cabecalho",
};
